<template>
  <v-page page="Tickets" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-1>
                  <v-flex align-center>
                    <div
                      v-if="BAN == 'all'"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Tickets</div>
                    <div
                      v-if="BAN !== 'all'"
                      v-show="showResetBtn && !loading"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Tickets for Account # {{ BAN }}</div>
                  </v-flex>
                  <v-flex align-center xs8>
                    <v-layout row>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlStatusId"
                          v-model="filters.StatusId"
                          item-text="Text"
                          item-value="Value"
                          label="Status"
                          clearable
                          @change="filterTickets"
                        >
                          <template slot="selection" slot-scope="data">
                            <v-layout row>
                              <v-flex
                                :class="{'green--text': data.item.Value === 'A2', 'red--text': data.item.Value === 'A1'}"
                              >{{ data.item.Text }}</v-flex>
                            </v-layout>
                          </template>
                          <template slot="item" slot-scope="data">
                            <v-layout row>
                              <v-flex
                                :class="{'green--text': data.item.Value === 'A2', 'red--text': data.item.Value === 'A1'}"
                              >{{ data.item.Text }}</v-flex>
                            </v-layout>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlType"
                          v-model="filters.Type"
                          item-text="Text"
                          item-value="Text"
                          label="Type"
                          clearable
                          @change="filterTickets"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-menu
                          v-model="openDate"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filters.Date"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterTickets"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filters.Date"
                            @input="openDate = false"
                            @change="filterTickets"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlUsername"
                          v-model="filters.Username"
                          item-text="Text"
                          item-value="Text"
                          label="Username"
                          clearable
                          @change="filterTickets"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs3 ml-5>
                        <v-layout row>
                        <v-text-field
                          v-model="search"
                          label="Search"
                          single-line
                          hide-details
                          class="align-center mt-0 pt-0"
                          @keyup.enter="filterTickets"
                        ></v-text-field>
                        <v-btn @click="filterTickets" icon mx-2 class="TierButton my-0 py-0">
                    <v-icon style="font-size:18px">fa-search</v-icon>
                  </v-btn>
                  </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <!-- <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="exportToExcel"
                          target="_blank"
                          >EXPORT TO EXCEL</a
                        >
                        <v-btn class="TierButton mb-1 mr-2 ml-1" @click="exportToExcel">
                      <v-icon>fa-file-excel</v-icon> &nbsp; Excel-->
                      <!-- </v-btn> -->
                      <v-btn
                        class="TierButton mb-1 mr-0 ml-1"
                        @click="openCreateTicketForm().then(()=>{$vuetify.goTo('#createTicket')})"
                      >+ New Ticket</v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- SERVICES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="tickets"
                  :item-key="tickets.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr
                      :key="props.index"
                      :active="props.selected"
                      :style="{
                        backgroundColor: (props.item.TicketId == selectedRow ? '#C6EFCE' : (isEven(props.index) ? '#f9f9f9': 'transparent') ), 
                        color: (props.item.TicketId == selectedRow ? '#00612e' : 'black' ),
                      }"
                    >
                      <!-- #009392 -->
                      <td class="text-xs-left px-0"><text-highlight :queries="searchHighlight">{{ props.item["TicketId"] }}</text-highlight></td>
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        ><text-highlight :queries="searchHighlight">{{ props.item["AccountBAN"] }}</text-highlight></router-link>
                      </td>

                      <td
                        class="text-xs-left px-0"
                        :class="{'green--text': props.item.StatusId === 'A2', 'red--text': props.item.StatusId === 'A1'}"
                      ><text-highlight :queries="searchHighlight">{{ props.item.StatusId == 'A1' ? "OPEN" : "CLOSED"}}</text-highlight></td>

                      <td class="text-xs-left pl-0 pr-3"><text-highlight :queries="searchHighlight">{{ props.item["Type"] }}</text-highlight></td>
                      <!-- <td class="text-xs-left px-0">{{ props.item["OpenDate"] | formatDateTime}}</td> -->

                      <td class="text-xs-left px-0 fill-width" colspan="3" >
                        <v-layout child-flex v-for="(details, index) in props.item.Details" row wrap>
                          <tr :key="index" class="fill-width" :class="{ticketDetail: index+1 < props.item.Details.length? true:false}">
                            <v-layout class="fill-width">
                              <v-flex style="width:17%; min-width:200px">
                                <td class="text-xs-left px-0">
                                  <v-layout column>
                                    <v-flex><text-highlight :queries="searchHighlight">{{details.USUSERNAME}}</text-highlight></v-flex>
                                    <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                  </v-layout>
                                </td>
                              </v-flex>
                              <v-flex style="width:16%; min-width:100px">
                                <td class="text-xs-left px-0">
                                  <v-layout column>
                                    <v-flex><text-highlight :queries="searchHighlight">{{details.ACENTRYDATE | formatDateTime}}</text-highlight></v-flex>
                                    <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                  </v-layout>
                                </td>
                              </v-flex>
                              <v-flex style="width:67%; min-width:200px">
                                <td class="text-xs-left px-0">
                                  <v-layout column>
                                    <v-flex><text-highlight :queries="searchHighlight">{{details.ACDETAIL}}</text-highlight></v-flex>
                                    <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                  </v-layout>
                                </td>
                              </v-flex>
                            </v-layout>
                          </tr>
                        </v-layout>
                      </td>

                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <a
                          v-if="props.item.StatusId == 'A1'"
                          class="mr-0"
                          style="text-decoration: none"
                          @click="openEditTicketForm(props.item).then(()=>{$vuetify.goTo('#createTicket')})"
                        >EDIT</a>
                        <a
                          class="mr-0"
                          v-if="props.item.StatusId == 'A2'"
                          style="text-decoration: none"
                          @click="reopenTicket(props.item)"
                        >REOPEN</a>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="pagination.totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetTicketsList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <createTicket @parentInitSelectedRow="initializeSelectedRow" id="createTicket" ref="createTicket"></createTicket>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import createTicket from "./CreateTicket.vue";
  import TextHighlight from 'vue-text-highlight';
  import DataTablePagination from "../../components/DataTablePagination.vue";
  import "@/assets/css/main.css"

export default {
  name: "Tickets",

  components: {
    VPage,
    createTicket,
      'text-highlight':TextHighlight,
      DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,

    BAN: "",

    showResetBtn: false,

    ddlUsername: [],
    ddlType: [],
    ddlStatusId: [],
    // ddlProvider: [],
    // ddlStatus: [],
    selectedRow: null,

    filters: {},
    filtersChanged: false,

    tickets: [],

    openDate: false,
    searchHighlight:"",

    options:{
      duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
    },

    rowsPerPageItems: [
      5,
      10,
      25,
      100
    ],

    // Selected by default
    pagination: {
      rowsPerPage: 5,
      descending: true,
      totalRecords: 0,
      sortBy: "OpenDate",
      page: 1
    },

    breadcrumb: [
      {
        text: "Tickets",
        disabled: false,
        href: "#/tickets/all"
      },
      {
        text: "All",
        disabled: true,
        href: "#/tickets/all"
      }
    ],

    headers: [
      {
        text: "Ticket #",
        value: "TicketId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "BAN",
        value: "AccountBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Status",
        value: "StatusId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Type",
        value: "Type",
        // sortable: false,
        width: "11%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Username",
        value: "Username",
        // sortable: false,
        width: "12.15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc ticketDetailColumn"
      },
      {
        text: "Date",
        value: "OpenDate",
        width: "12.50%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc ticketDetailCreatedColumn"
      },

      {
        text: "Note",
        value: "ACDETAIL",
        // sortable: false,
        width: "67%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "1%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    services: [],
    filteredServices: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route(to, from) {
      if (from.name == "tickets" && to.name == "tickets"){
      this.initialize()
      }
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },


  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};
      this.selectedRow = null;

      this.BAN = this.$route.params.BAN;

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
    }

      if (this.BAN !== "all") {
        this.filters = {
          AccountBAN: this.BAN
        };

        this.filtersChanged = true;

        this.breadcrumb[1].text = this.BAN;
        this.showResetBtn = true;
      } else {
        this.breadcrumb[1].text = "all";
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }

      //inits drop down filter lists
      this.getDropDownLists();

      var pagination = await this.paginationUpdated();

      this.initializeNewTicket()
      this.initializeEditTicket()

      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    getDropDownLists() {
      axios.get("/api/Tickets/GetTicketsDDLs/").then(res => {
        this.ddlUsername = res.data.ddlUsername;
        this.ddlType = res.data.ddlType;
        this.ddlStatusId = res.data.ddlStatusId;
      });
    },
    //if routed with newTicket then open new ticket component
    async initializeNewTicket() {
      var newTicket = this.$route.query.newTicket;
      if (typeof newTicket == "undefined" || newTicket == null) {
        //do nothing
      } else if (newTicket == "true") {
        var openCreateTicket = await this.openCreateTicketForm().then(()=>{
            document.getElementById("createTicket").scrollIntoView()})
      }
    },
    //if routed with newTicket then open new ticket component
    async initializeEditTicket() {
      var ticketId = this.$route.query.ticketId;
      if (typeof ticketId == "undefined" || ticketId == null) {
        //do nothing
      } else{
        let index = this.tickets.findIndex(x=>x.TicketId== ticketId )
        if (index>-1){
          var openEditTicket = await this.openEditTicketForm(this.tickets[index]).then(()=>{
            document.getElementById("createTicket").scrollIntoView()
          });
        }
      }
    },

    async resetTicketsList() {
      this.loading = true;
      this.$router.push("/tickets/all");

      this.filters = {};
      this.filtersChanged = true;
      this.searchHighlight=""
        this.search=""
      this.breadcrumb[1].text = "all";
      this.BAN = "all";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item.AccountBAN;
    },

    formatPN_helper(num) {
      let formattedNum =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return formattedNum;
    },

    async filterTickets() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    async openCreateTicketForm() {
      this.initializeSelectedRow()
      await this.$refs.createTicket.initialize();
      await this.$refs.createTicket.open({ BAN: this.BAN });
    },

    async openEditTicketForm(item) {
      let index = this.tickets.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.tickets[index].TicketId;
      }
      await this.$refs.createTicket.initialize();
      await this.$refs.createTicket.openEdit({
        BAN: item.AccountBAN,
        TicketId: item.TicketId,
        TypeId: item.TypeId,
        StatusId: item.StatusId
      });
    },
    // openServiceAuditLogs(item){
    //   // this.$refs.auditLogsService.openServiceAuditLogs(item);
    //   this.$router.push("/log/service/" + item)
    // },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Tickets/GetPagedTicketList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(async response => {
          this.tickets = await response.data.tickets;
          this.pagination.totalRecords = response.data.pagination.totalRecords;
          
           var newTicket = this.$route.params.newTicket;
          if (typeof newTicket == "undefined" || newTicket == null) {
            //do nothing
          } else if (newTicket == "true") {
            // var openCreateTicket = await this.openCreateTicketForm();
            var container = this.$refs.createTicket;
              container.scrollTop = container.scrollHeight;
              // alert(container.scrollHeight)
          }
          
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    exportToExcel() {
      var BAN = ""
      if (this.BAN != "all"){
BAN = this.BAN
      }
      axios({
        url: "/api/Excel/tickets/"+BAN,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var currentDate = moment().format("YYYYMMDD.HHmm");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Tickets." + currentDate + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    async reopenTicket(item) {
      var message =
        "Are you sure you would like to reopen Ticket #" + item.TicketId + "?";
      var confirmReopen = confirm(message);
      var detail = "Ticket Reopened";
      var status = "A1";
      if (confirmReopen == true) {
        var ticket = {
          AccountNumber: item.AccountBAN,
          TicketId: item.TicketId,
          TypeId: item.TypeId,
          Status: "A1",
          Detail: detail
        };
          var result = await axios.post('api/Tickets/AddTicketDetail', ticket)
          let ticketStatusResult = await axios
            .post('api/Tickets/UpdateTicketStatus', ticket)
            .then(res => {
              this.initialize()
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      initializeSelectedRow () {
        this.selectedRow = null
      },
      isEven (n) {
        if (!isNaN(n)) {
          return n % 2 === 0
        }
      },
      updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }

    }
  }
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
.ticketDetail{
  border-bottom:1px solid #e0e0e0 !important;
}
/deep/.ticketDetailColumn{
  min-width:200px!important
}
/deep/.ticketDetailCreatedColumn{
  min-width:100px!important
}

</style>
